import { useEffect, useState } from "react";
import { GetProfile } from "../queries";
import { useQuery, useMutation } from "@apollo/react-hooks";
import useInputState from "../../../hooks/useInputState";
import { UpdateAccountInfo } from "../../Onboarding/PolicyLinks/mutations";
import DefaultToaster from "../../../atoms/DefaultToaster";
import { Intent } from "@blueprintjs/core";
import useTutorialsState from "../../../hooks/useTutorialsState";
import useTagAccount from "../../../hooks/useTagAccount";

export const useChangePoliticalInfo = () => {
  const { data, loading } = useQuery(GetProfile);
  const [politicalDisclaimer, setPoliticalDisclaimer] = useInputState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState();
  const { getHasCompletedTutorial, completeTutorial } = useTutorialsState();
  const { tagAccount } = useTagAccount();

  const account = data && data.accounts && data.accounts[0];

  useEffect(() => {
    account && setPoliticalDisclaimer(account.politicalDisclaimer);
  }, [account]);

  const [updatePoliticalDisclaimer] = useMutation(UpdateAccountInfo, {
    refetchQueries: [{ query: GetProfile }]
  });

  const saveChanges = async () => {
    setIsSaving(true);
    setError(undefined);

    try {
      await updatePoliticalDisclaimer({
        variables: {
          account: {
            politicalDisclaimer
          }
        }
      });
      setIsSaving(false);

      const hasCustomizedPoliticalDisclaimer = getHasCompletedTutorial(
        "Add Customized Political Disclaimer"
      );

      if (!hasCustomizedPoliticalDisclaimer) {
        await completeTutorial({
          variables: {
            name: "Add Customized Political Disclaimer",
            version: 1
          }
        });

        await tagAccount("Political Disclaimer Customized");
      }

      DefaultToaster.show({
        message: "Political disclaimer updated!",
        icon: "tick",
        intent: Intent.SUCCESS
      });
    } catch (err) {
      setError({
        message: "An error occurred while updating the record."
      });
    }
  };

  return {
    politicalDisclaimer,
    setPoliticalDisclaimer,
    isSaving,
    error,
    saveChanges,
    loading: loading || !data,
    isSaveEnabled:
      politicalDisclaimer &&
      account &&
      politicalDisclaimer !== account.politicalDisclaimer &&
      !isSaving
  };
};
